import React from 'react'
import { IntlProvider } from 'react-intl'
import ReactDOM from 'react-dom'
import querystring from 'querystring'
import _ from 'lodash'
import 'lib/hotnessNotifier'

import MultiRouteEmbed from 'features/embed/MultiRouteEmbed'
import { TripRouteEmbed } from 'features/embed/TripRouteEmbed'
import { RegionalEmbedApp } from 'features/embed/RegionalEmbed'
import { EventsEmbed } from 'features/embed/EventsEmbed'
import { PublicEmbedApp } from 'features/embed/PublicEmbed'

const root = document.getElementById('ridewithgps-embed')
const embedTypes = {
  event: MultiRouteEmbed,
  trip: TripRouteEmbed,
  route: TripRouteEmbed,
  region: RegionalEmbedApp,
  events: EventsEmbed,
  publicExperience: PublicEmbedApp,
  publicEvent: PublicEmbedApp
}
const params = querystring.parse(window.location.search.substring(1))
const EmbedType = embedTypes[params.type] || MultiRouteEmbed
const embedProps = _.pick(params, Object.keys(EmbedType.propTypes))

ReactDOM.render(
  <IntlProvider locale={'en'} defaultLocale='en' messages={{}} key={{}}>
    <EmbedType {...embedProps} />
  </IntlProvider>, root)
